import {LanguageMenuModuleController} from "../language-menu-module.controller";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";

export class LanguageMenuModuleProps extends BaseModuleProps {
  controller: LanguageMenuModuleController;
}
